import { ReactNode, useMemo } from 'react';

import * as DialogPrimitive from '@radix-ui/react-dialog';

import { ModalContext, SIZES } from './context';
import { ModalBody } from './ModalBody';
import { ModalButton } from './ModalButton';
import { ModalClose } from './ModalClose';
import { ModalContent } from './ModalContent';
import { ModalFooter } from './ModalFooter';
import { ModalHeader } from './ModalHeader';
import { ModalOverlay } from './ModalOverlay';
import { ModalTitle } from './ModalTitle';
import { ModalTrigger } from './ModalTrigger';

function Modal({
  children,
  overlay = true,
  size = 'md',
  unwrap,
  ...props
}: DialogPrimitive.DialogProps & {
  readonly overlay?: boolean | ReactNode;
  readonly unwrap?: boolean;
  readonly size?: keyof typeof SIZES;
}) {
  const context = useMemo(() => {
    return {
      size,
    };
  }, [size]);

  return (
    <DialogPrimitive.Root {...props}>
      <ModalContext.Provider value={context}>
        {overlay === true ? <ModalOverlay /> : overlay ?? null}
        {unwrap ? children : <ModalContent>{children}</ModalContent>}
      </ModalContext.Provider>
    </DialogPrimitive.Root>
  );
}

Modal.Content = ModalContent;
Modal.Overlay = ModalOverlay;
Modal.Title = ModalTitle;
Modal.Close = ModalClose;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Header = ModalHeader;
Modal.Trigger = ModalTrigger;
Modal.Button = ModalButton;

export { Modal };
